import type { RunVercelResult } from '@cli-types/next-adapter/vercel.js'

/**
 * `create-store --yes` creates the store first and only then connects it; the connect step fails
 * when the linked project already has a BLOB_READ_WRITE_TOKEN env var — i.e. a Blob store is
 * already connected and its token is reusable via env pull. No store name can succeed here.
 */
export function isEnvVarConflict(result: RunVercelResult): boolean {
  return /already has an existing environment variable/i.test(`${result.stdout}\n${result.stderr}`)
}
